function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module font/documentcolorcollection
 */
import { Collection, ObservableMixin, mix } from 'ckeditor5/src/utils';
/**
 * A collection to store document colors. It enforces colors to be unique.
 *
 * @mixes module:utils/observablemixin~ObservableMixin
 * @extends module:utils/collection~Collection
 */

var DocumentColorCollection =
/*#__PURE__*/
function (_Collection) {
  _inherits(DocumentColorCollection, _Collection);

  function DocumentColorCollection(options) {
    var _this;

    _classCallCheck(this, DocumentColorCollection);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DocumentColorCollection).call(this, options));
    /**
     * Indicates whether the document color collection is empty.
     *
     * @observable
     * @readonly
     * @member {Boolean} #isEmpty
     */

    _this.set('isEmpty', true);

    _this.on('change', function () {
      _this.set('isEmpty', _this.length === 0);
    });

    return _this;
  }
  /**
   * Adds a color to the document color collection.
   *
   * This method ensures that no color duplicates are inserted (compared using
   * the color value of the {@link module:ui/colorgrid/colorgrid~ColorDefinition}).
   *
   * If the item does not have an ID, it will be automatically generated and set on the item.
   *
   * @chainable
   * @param {module:ui/colorgrid/colorgrid~ColorDefinition} item
   * @param {Number} [index] The position of the item in the collection. The item
   * is pushed to the collection when `index` is not specified.
   * @fires add
   * @fires change
   */


  _createClass(DocumentColorCollection, [{
    key: "add",
    value: function add(item, index) {
      if (this.find(function (element) {
        return element.color === item.color;
      })) {
        // No duplicates are allowed.
        return;
      }

      _get(_getPrototypeOf(DocumentColorCollection.prototype), "add", this).call(this, item, index);
    }
    /**
     * Checks if an object with given colors is present in the document color collection.
     *
     * @param {String} color
     * @returns {Boolean}
     */

  }, {
    key: "hasColor",
    value: function hasColor(color) {
      return !!this.find(function (item) {
        return item.color === color;
      });
    }
  }]);

  return DocumentColorCollection;
}(Collection);

export { DocumentColorCollection as default };
mix(DocumentColorCollection, ObservableMixin);